<template>
  <span v-if="cybersourceDetailsLoading" />
  <form v-else :action="cybersourceDetails.url || ''" method="post" ref="form">
    <input
      type="hidden"
      id="access_key"
      name="access_key"
      v-model="cybersourceDetails.access_key"
    />

    <input
      type="hidden"
      id="profile_id"
      name="profile_id"
      v-model="cybersourceDetails.profile_id"
    />

    <input
      type="hidden"
      id="transaction_uuid"
      name="transaction_uuid"
      v-model="cybersourceDetails.transaction_uuid"
    />

    <input
      type="hidden"
      id="signed_field_names"
      name="signed_field_names"
      v-model="cybersourceDetails.signed_field_names"
    />

    <input
      type="hidden"
      id="unsigned_field_names"
      name="unsigned_field_names"
      v-model="cybersourceDetails.unsigned_field_names"
    />

    <input
      type="hidden"
      id="signed_date_time"
      name="signed_date_time"
      v-model="cybersourceDetails.signed_date_time"
    />

    <input type="hidden" id="locale" name="locale" v-model="cybersourceDetails.locale" />

    <input
      type="hidden"
      id="transaction_type"
      name="transaction_type"
      v-model="cybersourceDetails.transaction_type"
    />

    <input
      type="hidden"
      id="reference_number"
      name="reference_number"
      v-model="cybersourceDetails.reference_number"
    />

    <input type="hidden" id="currency" name="currency" v-model="cybersourceDetails.currency" />

    <input
      type="hidden"
      id="bill_to_address_country"
      name="bill_to_address_country"
      v-model="cybersourceDetails.bill_to_address_country"
    />

    <input type="hidden" id="amount" name="amount" v-model="cybersourceDetails.amount" />

    <input type="hidden" id="signature" name="signature" v-model="cybersourceDetails.signature" />

    <input
      type="hidden"
      id="doShutOffCreditCards"
      name="doShutOffCreditCards"
      v-model="cybersourceDetails.doShutOffCreditCards"
    />
  </form>
</template>

<script>
/*
 * Vue 3 Conversion Notes:
 *
 * if you are going to refactor this page, you must STILL use the form.submit()
 * instead of refactoring to a programmatic submit.  The latter will force a CORS
 * preflight, and Cybersource cannot be configured for one, so it will always fail.
 * Note:  in the browser, it will look like a CSP error.  Don't be fooled.
 *
 */
  import billing from '@mixins/billing';
  import { mapFields } from 'vuex-map-fields';
  import { mapGetters } from 'vuex';

  export default {
    mixins: [billing],
    methods: {
      submit() {
        if (this.$refs.form) this.$refs.form.submit()
      }
    },
    computed: {
      cybersourceDetails() {
        return this.$store.getters['cybersourceDetails'] || {};
      },
      cybersourceDetailsLoading() {
        return this.$store.getters['cybersourceDetailsLoading'] || false;
      },
      // ...mapFields([
      //   'billing.cybersourceDetails.amount',
      //   'billing.cybersourceDetails.access_key',
      //   'billing.cybersourceDetails.profile_id',
      //   'billing.cybersourceDetails.transaction_uuid',
      //   'billing.cybersourceDetails.signed_field_names',
      //   'billing.cybersourceDetails.unsigned_field_names',
      //   'billing.cybersourceDetails.signed_date_time',
      //   'billing.cybersourceDetails.locale',
      //   'billing.cybersourceDetails.transaction_type',
      //   'billing.cybersourceDetails.reference_number',
      //   'billing.cybersourceDetails.currency',
      //   'billing.cybersourceDetails.bill_to_address_country',
      //   'billing.cybersourceDetails.signature',
      //   'billing.cybersourceDetails.doShutOffCreditCards',
      //   'billing.cybersourceDetails.url',
      // ])
    }
  }
</script>
